export function randomFromArray(array) {
  // Thank you https://stackoverflow.com/questions/5915096/get-a-random-item-from-a-javascript-array
  return array[Math.floor(Math.random() * array.length)];
}
